import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Container,
  Input,
  Form,
} from "reactstrap";
import { API_BASE_URL, API_KEY, getCookie } from "../../constants/utilis";
import axios from "axios";
import uploadFile from "./s3/s3.upload";

const LandingKartForm = () => {
    const [formData, setFormData] = useState({
        customername: "",
        customername: "", // borrowername
        productname: "", // Type of proposal
        qpersonmet: "", // contact person
      applicationid: "",
      qofficeaddress: "", // pdAddress
      mobilenumber: "",
      constitution: "",
      business: "",
      agentname: "", // pd done by
      createdat: "", // pdDate
      familyBackground: "",
      residenceownership: "",
      residenceStability: "",
      businessBackground: "",
      qnature: "", // nature of business
      otherOfficeDetails: "",
      businessOwnership: "",
      employees: "",
      alternateBusinesses: "",
      otherIncomes: "",
      qbusinessproof: "", // document seen
      suppliers: "",
      customers: "",
      qapproxincome: "", // turnover
      margin: "",
      salaryPaid: "",
      qcpvstatus: "", // caseResult
      latitude: "",
      longitude: "",
      caseAnalysis: "",
      pep: "",
      qsignboardtext: "", // firmBoardSeen
      tpcFeedback: "",
      verifierSignature: "",
      agencySignature: "",
      images: [],
      locationcoordinates: "",
      qagentremarks: "",
      qrejectreason: "",
      qpersonmetdesignation: "",
      qofficeownership: "",
      qnumberemployees: "",
      qtpc1: "",
      qtpc2: "",
      coapplicantname: "",
    });
  
    const handleChange = (event) => {
      setFormData({
        ...formData,
        [event.target.name]: event.target.value,
      });
    };

  
    // const handleSubmit = async (e) => {
    //   e.preventDefault();
  
    //   const config = {
    //     method: "put",
    //     url: `${API_BASE_URL}/auth/case/${caseId}`,
    //     headers: {
    //       apikey: API_KEY,
    //       Authorization: `Bearer ${getCookie("at")}`,
    //     },
    //     data: formData,
    //   };

    //   console.log("Form data being sent:", formData);
    //   clearFormData();
  
    //   try {
    //     const response = await axios(config);
    //     console.log("Form submitted successfully:", response.data);
    //     alert("Form submitted successfully!");
    //     clearFormData();
    //   } catch (error) {
    //     console.error("Error submitting the form:", error);
    //     alert("Failed to submit form. Please try again.");
    //   }
    // };
  
    // const [data, setData] = useState({
    //     firmName: "",
    //     borrowerName: "",
    //     // Add more fields as needed
    //   });

    //   let caseId = sessionStorage.getItem("caseId");
    // let caseId = "67f61bdc7084aca8376bde60";
    let caseId = "67f7b8740bd2c0bed1f893a8";
    
      // Fetch data from API when component loads
      const fetchData = async () => {
        try {
          const res = await axios.get(`${API_BASE_URL}/auth/case/${caseId}`, {
            headers: {
              apikey: API_KEY,
              Authorization: `Bearer ${getCookie("at")}`,
            },
          });
    
          if (res.data) {
            setFormData({
                customername: res.data.customername || "",
                customername: res.data.customername || "",
              applicationid: res.data.applicationid || "",
              productname: res.data.productname || "",
              mobilenumber: res.data.mobilenumber || "",
              createdat: res.data.createdat || "",
              agentname: res.data.agentname || "",
              locationcoordinates: res.data.locationcoordinates || "",
              qofficeaddress: res.data.qofficeaddress || "",
              qagentremarks: res.data.qagentremarks || "",
              qrejectreason: res.data.qrejectreason || "",
              qpersonmet: res.data.qpersonmet || "",
              qpersonmetdesignation: res.data.qpersonmetdesignation || "",
              qworkingsince: res.data.qworkingsince || "",
              qofficeownership: res.data.qofficeownership || "",
              qnature: res.data.qnature || "",
              qsignboardtext: res.data.qsignboardtext || "",
              qnumberemployees: res.data.qnumberemployees || "",
              qbusinessproof: res.data.qbusinessproof || "",
              qtpc1: res.data.qtpc1 || "",
              qtpc2: res.data.qtpc2 || "",
              qapproxincome: res.data.qapproxincome || "",
              qcpvstatus: res.data.qcpvstatus || "",
              residenceownership: res.data.residenceownership || "",
              coapplicantname: res.data.coapplicantname || "",
              // Add other fields here
            });
          }
        } catch (err) {
          console.error("Error fetching case data:", err);
        }
      };
    
      // Initial load
      useEffect(() => {
        if (caseId) {
          fetchData();
        }
      }, [caseId]);
    
      // Handle change in inputs
    //   const handleChange = (e) => {
    //     setFormData((prev) => ({
    //       ...prev,
    //       [e.target.name]: e.target.value,
    //     }));
    //   };
    
      // Handle form submission (PUT request)
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
          const response = await axios.put(
            `${API_BASE_URL}/auth/case/${caseId}`,
            formData,
            {
              headers: {
                apikey: API_KEY,
                Authorization: `Bearer ${getCookie("at")}`,
                "Content-Type": "application/json",
              },
            }
          );
    
          if (response.status === 200) {
            alert("Updated successfully");
            fetchData(); // fetch updated values again to reflect in form
          }
        } catch (err) {
          console.error("Error updating case:", err);
          alert("Update failed");
        }
      };

    return (
      <Container fluid className="mt-5 mb-5 pt-4 pb-4">
        <Card>
          <CardBody>
            <h3 className="mb-4">LendingKart Report Form</h3>
            <Form onSubmit={handleSubmit}>
              <Row>
                <h5 className="mt-4 mb-3 text-primary">Customer Details</h5>

                <Col md="12" className="mb-3 bg-light p-3">
                    <p><strong>Customer Name:</strong> {formData.customername || "N/A"}</p>
                    <p><strong>Application ID:</strong> {formData.applicationid || "N/A"}</p>
                    <p><strong>Mobile Number:</strong> {formData.mobilenumber || "N/A"}</p>
                    <p><strong>Product Name:</strong> {formData.productname || "N/A"}</p>
                </Col>
                
                <Col md="12">
                    <h5 className="mt-4 mb-3 text-primary">Personal Details</h5>
                </Col>
                <Col md="6" className="mb-3">
                  <FormGroup>
                    <Label for="customername">Firm / Business Name</Label>
                    <Input
                      type="text"
                      name="customername"
                      id="customername"
                      value={formData.customername}
                      onChange={handleChange}
                      placeholder="Enter Firm Name"
                    />
                  </FormGroup>
                </Col>
  
                <Col md="6" className="mb-3">
                  <FormGroup>
                    <Label for="customername">Borrower / Customer Name</Label>
                    <Input
                      type="text"
                      name="customername"
                      id="customername"
                      value={formData.customername}
                      onChange={handleChange}
                      placeholder="Enter Borrower Name"
                    />
                  </FormGroup>
                </Col>
  
                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Persone met during visit */}
                    <Label for="qpersonmet">Contact Person</Label> 
                    <Input
                      type="text"
                      name="qpersonmet"
                      id="qpersonmet"
                      value={formData.qpersonmet}
                      onChange={handleChange}
                      placeholder="Enter Contact Person"
                    />
                  </FormGroup>
                </Col>
  
                <Col md="6" className="mb-3">
                  <FormGroup>
                    <Label for="applicationid">Application ID</Label>
                    <Input
                      type="text"
                      name="applicationid"
                      id="applicationid"
                      value={formData.applicationid}
                      onChange={handleChange}
                      placeholder="Enter Application ID"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* family members  */}
                    <Label for="qfamilymemberscount">Family Members / Background</Label>
                    <Input
                      type="text"
                      name="qfamilymemberscount"
                      id="qfamilymemberscount"
                      value={formData.qfamilymemberscount}
                      onChange={handleChange}
                      placeholder="Enter"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Ownership residence */}
                    <Label for="residenceownership">Ownership Of Residence</Label>
                    <Input
                      type="text"
                      name="residenceownership"
                      id="residenceownership"
                      value={formData.residenceownership}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="12">
                    <h5 className="mt-4 mb-3 text-primary">Other Information</h5>
                </Col>

                {/* <Col md="6" className="mb-3">
                  <FormGroup>
                    Stability
                    <Label for="pdDate">Stability At Same Address</Label>
                    <Input
                      type="text"
                      name="pdDate"
                      id="pdDate"
                      value={formData.pdDate}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col> */}
  
                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Address */}
                    <Label for="qofficeaddress">PD Done at (Address)</Label>
                    <Input
                      type="text"
                      name="qofficeaddress"
                      id="qofficeaddress"
                      value={formData.qofficeaddress}
                      onChange={handleChange}
                      placeholder="Enter PD Address"
                    />
                  </FormGroup>
                </Col>
  
                <Col md="6" className="mb-3">
                  <FormGroup>
                    <Label for="mobilenumber">Mobile No.</Label>
                    <Input
                      type="number"
                      name="mobilenumber"
                      id="mobilenumber"
                      value={formData.mobilenumber}
                      onChange={handleChange}
                      placeholder="Enter Mobile No."
                    />
                  </FormGroup>
                </Col>
  
                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* is business permises owned or rented */}
                    <Label for="qofficeownership">Constitution / Ownership Of Business</Label>
                    <Input
                      type="text"
                      name="qofficeownership"
                      id="qofficeownership"
                      value={formData.qofficeownership}
                      onChange={handleChange}
                      placeholder="Enter Constitution"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Verifier Emp Name */}
                    <Label for="agentname">PD Done By</Label>
                    <Input
                      type="text"
                      name="agentname"
                      id="agentname"
                      value={formData.agentname}
                      onChange={handleChange}
                      placeholder="Enter PD Done By"
                    />
                  </FormGroup>
                </Col>

                <Col md="12">
                    <h5 className="mt-4 mb-3 text-primary">Business Information</h5>
                </Col>
  
                <Col md="6" className="mb-3">
                  <FormGroup>
                    <Label for="business">Business</Label>
                    <Input
                      type="text"
                      name="business"
                      id="business"
                      value={formData.business}
                      onChange={handleChange}
                      placeholder="Enter Business"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                    <FormGroup>
                        <Label for="qnumberemployees">No. Of Employees</Label>
                        <Input
                        type="text"
                        name="qnumberemployees"
                        id="qnumberemployees"
                        value={formData.qnumberemployees}
                        onChange={handleChange}
                        placeholder="Enter Family Background"
                        />
                    </FormGroup>
                </Col>
  
                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Time of Allocation */}
                    <Label for="createdat">Date Of PD</Label>
                    <Input
                      type="text"
                      name="createdat"
                      id="createdat"
                      value={formData.createdat}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                      disabled
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Product */}
                    <Label for="productname">Type of Propsal / Product Name</Label>
                    <Input
                      type="text"
                      name="productname"
                      id="productname"
                      value={formData.productname}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Designation of person met */}
                    <Label for="qpersonmetdesignation">Proprietor / Partner</Label>
                    <Input
                      type="text"
                      name="qpersonmetdesignation"
                      id="qpersonmetdesignation"
                      value={formData.qpersonmetdesignation}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Working Since */}
                    <Label for="qworkingsince">Business Stability Since</Label>
                    <Input
                      type="text"
                      name="qworkingsince"
                      id="qworkingsince"
                      value={formData.qworkingsince}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Name mentioned on sign board */}
                    <Label for="qsignboardtext">Firm Name Board seen / not seen</Label>
                    <Input
                      type="text"
                      name="qsignboardtext"
                      id="qsignboardtext"
                      value={formData.qsignboardtext}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Submitted Loc */}
                    <Label for="locationcoordinates">Submitted Loc</Label>
                    <Input
                      type="text"
                      name="locationcoordinates"
                      id="locationcoordinates"
                      value={formData.locationcoordinates}
                      onChange={handleChange}
                      placeholder="Latitude / Longitude"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Nature of business */}
                    <Label for="qnature">Nature Of Business</Label>
                    <Input
                      type="text"
                      name="qnature"
                      id="qnature"
                      value={formData.qnature}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Proof of office seen */}
                    <Label for="qbusinessproof">Document Seen</Label>
                    <Input
                      type="text"
                      name="qbusinessproof"
                      id="qbusinessproof"
                      value={formData.qbusinessproof}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* TPC Name 1 */}
                    <Label for="qtpc1">TPC Name 1</Label>
                    <Input
                      type="text"
                      name="qtpc1"
                      id="qtpc1"
                      value={formData.qtpc1}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* TPC Name 2 */}
                    <Label for="qtpc2">TPC Name 2</Label>
                    <Input
                      type="text"
                      name="qtpc2"
                      id="qtpc2"
                      value={formData.qtpc2}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Occupation / Source of Income */}
                    <Label for="staffSalary">Staff Salary</Label>
                    <Input
                      type="text"
                      name="staffSalary"
                      id="staffSalary"
                      value={formData.staffSalary}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Approx Income */}
                    <Label for="qapproxincome">Turn Over</Label>
                    <Input
                      type="text"
                      name="qapproxincome"
                      id="qapproxincome"
                      value={formData.qapproxincome}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/*  */}
                    <Label for="margin">Margin</Label>
                    <Input
                      type="text"
                      name="margin"
                      id="margin"
                      value={formData.margin}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/*  */}
                    <Label for="pep">PEP</Label>
                    <Input
                      type="text"
                      name="pep"
                      id="pep"
                      value={formData.pep}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/*  */}
                    <Label for="coapplicantname">Name Of The Suppliers / Co-Applicant</Label>
                    <Input
                      type="text"
                      name="coapplicantname"
                      id="coapplicantname"
                      value={formData.coapplicantname}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/*  */}
                    <Label for="alternateBusiness">Alternat Business if any</Label>
                    <Input
                      type="text"
                      name="alternateBusiness"
                      id="alternateBusiness"
                      value={formData.alternateBusiness}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/*  */}
                    <Label for="anotherOffice">Another Office / Godown / Branches</Label>
                    <Input
                      type="text"
                      name="anotherOffice"
                      id="anotherOffice"
                      value={formData.anotherOffice}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Internal Backcheck */}
                    <Label for="internalBackcheck">Case Analysis</Label>
                    <Input
                      type="text"
                      name="internalBackcheck"
                      id="internalBackcheck"
                      value={formData.internalBackcheck}
                      onChange={handleChange}
                      placeholder="Enter Date of PD"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Agent Remarks */}
                    <Label for="qagentremarks">Agent Remarks</Label>
                    <Input
                      type="text"
                      name="qagentremarks"
                      id="qagentremarks"
                      value={formData.qagentremarks}
                      onChange={handleChange}
                      placeholder="Enter Agent Remarks"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                  <FormGroup>
                    {/* Reject Reason */}
                    <Label for="qrejectreason">Reject Reason</Label>
                    <Input
                      type="text"
                      name="qrejectreason"
                      id="qrejectreason"
                      value={formData.qrejectreason}
                      onChange={handleChange}
                      placeholder="Enter Reject Reason"
                    />
                  </FormGroup>
                </Col>

                <Col md="6" className="mb-3">
                    <FormGroup>
                        <Label for="qcpvstatus">Case Status / Result</Label>
                        <Input
                        type="select"
                        name="qcpvstatus"
                        id="qcpvstatus"
                        value={formData.qcpvstatus}
                        onChange={handleChange}
                        >
                        <option value="">Select Case Status</option>
                        <option value="Positive">Positive</option>
                        <option value="Negative">Negative</option>
                        <option value="Refer to Credit">Refer to Credit</option>
                        {/* <option value="Negative">Negative</option> */}
                        </Input>
                    </FormGroup>
                </Col>
                {/* Repeat this pattern for all other fields */}

                

                
              </Row>
              <Button color="primary" type="submit">
                Submit
              </Button>
            </Form>
          </CardBody>
        </Card>
      </Container>
    );
  };
  
export default LandingKartForm;
